// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rv-0";